import { useMemo } from 'react';

import { useFlags } from '@mint-lib/routing-context';
import { useRouterState, type NavigateOptions } from '@mint/routing';
import isMobile from 'is-mobile';
import { useAtom } from 'jotai';

import { agenticAiChatActiveAtom } from '../store/index.js';

const forbiddenAgenticAiPages: NavigateOptions['to'][] = [
  '/company-profile',
  '/ai-hub',
];

const forbiddenRecoPath: NavigateOptions['to'] = '/notifications';

const getIsAgenticAiAllowed = (
  pathname: string,
  isRecoAgentEnabled: boolean,
) => {
  const forbiddenPages = isRecoAgentEnabled
    ? forbiddenAgenticAiPages
    : [...forbiddenAgenticAiPages, forbiddenRecoPath];

  return !forbiddenPages.some((path) => path && pathname.startsWith(path));
};

const useAgenticModal = () => {
  const ff = useFlags('@mint/arm', ['agenticMetadata']);

  const currentPathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const isMobileDevice = isMobile();
  const [isChatManuallyActive, setIsChatManuallyActive] = useAtom(
    agenticAiChatActiveAtom,
  );

  const isAgenticAiAvailable =
    getIsAgenticAiAllowed(currentPathname, ff.agenticMetadata.enabled) &&
    !isMobileDevice;

  const isChatActive = useMemo(
    () => isChatManuallyActive && isAgenticAiAvailable,
    [isChatManuallyActive, isAgenticAiAvailable],
  );

  return {
    currentPathname,
    isAgenticAiAvailable,
    isChatActive,
    setIsChatManuallyActive,
  };
};

export default useAgenticModal;
